import { useTrialInformation } from './useTrialInformation.js'

export const useTrialStatus = () => {
  const { isTrial, isActive, isManual, trialEndDate, isLoading } =
    useTrialInformation()

  if (isLoading || isManual || !isTrial) {
    return {
      isTrialExpired: false,
      isTrialActive: false,
      trialEndDate: null,
      isLoading,
    }
  }

  const trialEndTime = trialEndDate ? new Date(trialEndDate).getTime() : null
  const hasTrialEndDate = trialEndTime !== null && !Number.isNaN(trialEndTime)
  const now = Date.now()
  const hasExpiredByDate = hasTrialEndDate ? trialEndTime <= now : false
  const isTrialExpired = hasExpiredByDate || !isActive
  const isTrialActive = !isTrialExpired

  return {
    isTrialExpired,
    isTrialActive,
    trialEndDate: isTrialActive && hasTrialEndDate ? trialEndDate : null,
    isLoading,
  }
}
